module.exports = __webpack_public_path__ + "img/cbguanl-icon.5a0d98e5.png";